import axios from 'axios'
import _ from 'lodash'

// state
const state = {
	user: {},
	dataForServer: {},    // variable to update or create new
	profileImageUrl: '',
    canSave: false,
    isLoading: false,
    savingError: false,
	canUploadFile: false,
	canSelectFile: false,
	emptyTokenError: false,			// show error when no token
	invalidTokenError: false,		// show error for incorrect token
	validToken: false,				// show valid token message
	retrieveSecret: false,			// confirm selection of email or text
	secretConfirm: false,			// verification code confirmed
	incorrectSecret: false,			// incorrect secret
	vendor: {},
	id: '',
	token: '',
	sendCodeLoader: false,
	verifyCodeLoader: false,
	resetToken: '',				// use for saving the password
	userName: '', 				// store user name
	resendSuccess: false,
	resendClicked: false
}

const getters = {
	/**
	 * Get user data for populating the form
	 * @return {object}
	 */
	getFormData (state) {
		var getData = state.user
		return getData;
	},

	/**
	 * Retrieve profile image url
	 * @return {string}
	 */
	getProfileImageUrl (state) {
		var getData = state.profileImageUrl
		return getData;
	},
	/**
	 * Get user data for populating the form
	 * @return {object}
	 */
	getvendor (state) {
		return state.vendor
	},
	
	getresetToken (state) {
		return state.resetToken
	},
	
	gettoken (state) {
		return state.token
	},
	
	getuserName (state) {
		return state.userName
	},

	getresendSuccess (state) {
		return state.resendSuccess
	},

}


// mutations
const mutations = {
	/**
	 * Mutate any variable
	 * @param {string}
	 * @param {value}
	 */
	SET_VARIABLE(state, {key, value}){
		eval('state.' + key + ' = value');
	},


	/**
	 * Mutate any boolean variable
	 * @param {string}
	 * @param {boolean}
	 */
	TOGGLE_BOOLEAN_STATE(state, {key, bool}){
		eval('state.' + key + ' = bool');
	},

	/**
	 * Set full path url for profile image
	 * @param {string}
	 */
	SET_PROFILE_IMAGE_URL (state, profileImageUrl){
		state.profileImageUrl = profileImageUrl
	},

	/**
	 * Set user data
	 * @param {object}
	 */
	SET_USER_DATA (state, {userData}){
		state.user = userData
	},

	/**
	 * Setup dataForServer object to push to API
	 */
	UPDATE_SELECTED_DATA(state, {key, value}){
		state.dataForServer[key] = value;

		// need to set user
		state.user[key] = value;
	},

	/**
	 * Set vendor data
	 * @param {object}
	 */
	SET_VENDOR_DATA (state, {vendorData}){
		state.vendor = vendorData
	},
}

// actions
const actions = {
	/** set variable
	 */
	setVariable({commit}, {key, value}){
		commit('SET_VARIABLE', {key: key, value: value});
	},

	/**
	 * Toggle boolean keys
	 * @param {string}
	 * @param {boolean}
	 */
	setBoolean({commit}, {key, bool}){
		commit('TOGGLE_BOOLEAN_STATE', {key: key, bool: bool});
	},

	/**
	 * Action to update keys and value
	 */
	updateSelectedData ({commit, state, dispatch}, key, value){
		commit('UPDATE_SELECTED_DATA', key, value)
	},

	/**
	 * Calls API to retrieve logged in user's profile
	 */
	getUserData({commit, dispatch, state, rootState}){
		var header = rootState.auth.header;
		var currentUser = rootState.auth.user;

		var url = rootState.auth.l+'v1/users/'+currentUser.id;

		axios.get(url,header)
			.then(response => {
				var getData = response.data.data;
				commit('SET_USER_DATA', {userData: getData});
				dispatch('setProfileImageUrl', getData.profile_image)
			}).catch((error) => {
				dispatch('auth/checkError', error, {root: true})
			});

	},

	/**
	 * Calls API to update user's profile
	 */
	update({commit, dispatch, state, getters, rootState, rootGetters}){
		var header = rootState.auth.header;
		var user_id = state.user.id;
		var dataForServer = state.dataForServer;

		// If user_id exist, update existing location
		if(typeof user_id !== 'undefined'){
			var url = rootState.auth.l+'v1/users/'+user_id;
			axios.put(url,dataForServer,header)
			.then(response => {
				
				commit('TOGGLE_BOOLEAN_STATE', {key: 'isLoading', bool: false})
				commit('TOGGLE_BOOLEAN_STATE', {key: 'canSave', bool: false})

				VueStore.dispatch('profile/setBoolean', {key: 'showSuccess', bool: true})
	            setTimeout(function(){
	                VueStore.dispatch('profile/setBoolean', {key: 'showSuccess', bool: false})
	            }, 5000);

			}).catch((error) => {
				dispatch('auth/checkError', error, {root: true})
			});
		// Create new location
		} else {
			commit('TOGGLE_BOOLEAN_STATE', {key: 'savingError', bool: true})
		}
	},

	setProfileImageUrl({commit, dispatch, rootState}, profileImage){
		var url = "";
		if(profileImage !== '' && profileImage !== null && profileImage !== undefined){
			url = rootState.auth.l + 'files?file=' + profileImage;
		}else{
			url = rootState.auth.l + 'files?file=avatars/0.png';
		}

		//dispatch('updateSelectedData', {'key': 'profile_image', 'value': profileImage});
		commit('SET_PROFILE_IMAGE_URL', url);
	},


	uploadUserProfile({commit, state, dispatch, getters, rootState, rootGetters}, file){
		var fileObj;

		let formData = new FormData();
		formData.append('file', file);
		formData.append('user_id', state.user.id);
		formData.append('file_desc', "User Profile");
		formData.append('avatar_subdirectory', "users");
		//formData.append('user', rootState.auth.user.username);

		var header = rootState.auth.header;
		//header['headers']['Content-Type'] = 'multipart/form-data';

		var url = rootState.auth.l+'v1/avatar-upload';

		axios.post(url,formData,header)
		.then(response => {
			VueStore.dispatch('notify/setShowMessage', {key: 'showUploadMessage', bool: true}, {root:true});

			VueStore.dispatch('fileUpload/toggleBooleanState', {key: 'canUploadFile', bool: false}, {root:true});

			dispatch('setProfileImageUrl', response.data.data.profile_image);

			VueStore.dispatch('profile/setBoolean', {key: 'showSuccess', bool: true})
            setTimeout(function(){
                VueStore.dispatch('profile/setBoolean', {key: 'showSuccess', bool: false})
            }, 5000);

		}).catch((error) => {
			dispatch('auth/checkError', error, {root: true})
		});


	},

	async checkToken({commit, dispatch, rootState}, data){
		var data = data;
		var url = rootState.auth.l+'vendor-signups/token';

		commit('SET_VARIABLE', {key: 'id', value: data.id})
		commit('SET_VARIABLE', {key: 'token', value: data.token})
		return axios.post(url,data)
			.then(response => {	
				if(response.data.data !== null){	
					var data = response.data.data.original.data;
					commit('SET_VENDOR_DATA', {vendorData: data});
				}

				if(typeof(response.data.status) !== 'undefined'){
					switch(response.data.status){
						// Contain result
						case '200':
							commit('SET_VARIABLE', {key: 'validToken', value: true});
							break;
						// No result
						// Token has expired
						case '404':
							commit('SET_VARIABLE', {key: 'invalidTokenError', value: true});
							break;
					}
				}

				return response;
			}).catch((error) => {
				console.log(error);
				commit('SET_VARIABLE', {key: 'invalidTokenError', value: true}); 
			});
	
	},

	sendCode({commit, dispatch, rootState}, option){
		var url = rootState.auth.l+'vendor-signups/sendcode';

		var data = {
			'id': state.id,
			'token': state.token,
			'option': option
		}
	
		axios.post(url,data)
			.then(response => {	
				if(response.data.data !== null){
					if(state.resendClicked){
						commit('SET_VARIABLE', {key: 'resendSuccess', value: true});

						// delay so auth store is loaded.
						setTimeout(function(){ 
							commit('SET_VARIABLE', {key: 'resendSuccess', value: false});
						}, 5000);
					}
					commit('SET_VARIABLE', {key: 'invalidTokenError', value: false}); 
					commit('SET_VARIABLE', {key: 'sendCodeLoader', value: false}); 
					commit('SET_VARIABLE', {key: 'retrieveSecret', value: true}); 
					commit('SET_VARIABLE', {key: 'validToken', value: false}); 
				}
			}).catch((error) => {
				console.log(error);
			});

	},

	verifyCode({commit, dispatch, rootState}, secretCode){
		var url = rootState.auth.l+'vendor-signups/verify';

		var data = {
			'id': state.id,
			'token': state.token,
			'secret_code': secretCode
		}
	
		axios.post(url,data)
			.then(response => {
				//console.log("response", response.data)
				var res = response.data;

				if(res.data != null){
					//console.log("id", res.data.id)
					VueStore.dispatch('passwordReset/setVariable', {key: 'userId' , value: res.data.id})
					commit('SET_VARIABLE', {key: 'userName', value: res.data.username}); 
					commit('SET_VARIABLE', {key: 'resetToken', value: res.reset_token}); 
					commit('SET_VARIABLE', {key: 'retrieveSecret', value: false}); 
					commit('SET_VARIABLE', {key: 'invalidTokenError', value: false}); 
					commit('SET_VARIABLE', {key: 'verifyCodeLoader', value: false}); 
					commit('SET_VARIABLE', {key: 'secretConfirm', value: true}); 
					commit('SET_VARIABLE', {key: 'validToken', value: false});
				} else {
					//console.log("status", res.status);
					
					commit('SET_VARIABLE', {key: 'incorrectSecret', value: true});
				}


			}).catch((error) => {
				console.log(error);
			});

	}
}

export default {
    namespaced: true,
	state,
	getters,
	mutations,
	actions
}